import { createApp } from 'vue'
import { createPinia } from 'pinia'

import 'material-icons/iconfont/filled.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import router from './router'
import App from './App.vue'

import vuetifyPlugin from '@/plugins/vuetify'
import { useFormatPrice } from '@/composables/useFormatPrice'
import { removeStoredApiData } from '@/stores/session.js'

// Data of the API is no longer kept in the localStorage; remove what older versions left there
removeStoredApiData()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(vuetifyPlugin)

app.config.globalProperties.$formatPrice = useFormatPrice()

app.mount('#app')
